import { h, Fragment } from 'preact'
import { useState, useEffect } from 'preact/hooks'
import { keygen } from '@utils/misc'
// function randomizator(a, b) {
//     return Math.floor(Math.random() * b) + a
// }

export default function Loader({ children, heights }) {
	const { mobile, landscape, tablet, desktop } = heights

	const loaderClassName = keygen('loader')

	return (
		<div className={`loader ${loaderClassName}`}>
			<style>
				{`
                    .${loaderClassName} { height: ${desktop} }
                    @media screen and (max-width: 1024px) { .${loaderClassName} { height: ${tablet}} }
                    @media screen and (max-width: 768px) { .${loaderClassName} { height: ${landscape}} }
                    @media screen and (max-width: 580px) { .${loaderClassName} { height: ${mobile}} }
                `}
			</style>

			{children}
		</div>
	)
}
